import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

/** Keep navigation explicit: a failed save leaves the teacher in the current draft. */
export function EbookUnsavedDialog({
  busy,
  error,
  onSave,
  onDiscard,
  onStay,
}: {
  busy: boolean;
  error: string;
  onSave: () => void;
  onDiscard: () => void;
  onStay: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    element?.showModal();
    return () => {
      element?.close();
      if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
    };
  }, []);
  return createPortal(
    <dialog
      ref={dialog}
      className="ebook-page ebook-teacher ebook-unsaved-dialog"
      aria-labelledby="ebook-unsaved-title"
      onCancel={(event) => {
        event.preventDefault();
        if (!busy) onStay();
      }}
    >
      <h2 id="ebook-unsaved-title">先保存当前修改？</h2>
      <p>当前教材有未保存内容。保存成功后继续，或放弃本次尚未保存的修改。</p>
      {error && (
        <p className="ebook-error" role="alert">
          {error}
        </p>
      )}
      <div className="ebook-actions">
        <button disabled={busy} onClick={onStay} autoFocus>
          继续编辑
        </button>
        <button disabled={busy} onClick={onDiscard}>
          放弃修改
        </button>
        <button disabled={busy} className="primary" onClick={onSave}>
          {busy ? '正在保存…' : '保存并继续'}
        </button>
      </div>
    </dialog>,
    document.body,
  );
}
